import React from 'react'
import styled from '@emotion/styled'
import Api from '../../utils/api'

import { responsive } from '../../utils/style'
import { css } from '@emotion/react'

export const RegisterFinish = (props) => {
  const { email } = props

  const onClickResend = async () => {
    await Api.post('/authen/resendConfirmation', { email })
      .then((res) => {
        alert(`ระบบได้ส่งอีเมลไปที่ ${email} อีกครั้ง`)
      })
      .catch((err) => {
        alert(err.response.data.message)
      })
  }

  return (
    <>
      <MessageBox>
        ระบบได้ส่งอีเมลไปที่ {email} <br />
        กรุณาตรวจสอบอีเมลของคุณเพื่อดำเนินการยืนยันตัวตน
      </MessageBox>
      <IfNot>หากท่านไม่ได้รับอีเมลยืนยัน</IfNot>
      <ResendButton onClick={onClickResend}>
        ส่งอีเมลยืนยันอีกครั้ง
      </ResendButton>
    </>
  )
}

const ResendButton = styled.button`
  width: 206px;
  height: 51px;
  left: 314px;
  top: 420px;

  /* Primary/Green 50 */

  background: #b5f6df;
  /* Primary/Green 400 */

  border: 1px solid #16af7b;
  border-radius: 100px;
  font-family: 'Noto Sans Thai';
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  /* identical to box height, or 121% */

  letter-spacing: -0.02em;

  /* Primary/Green 400 */

  color: #16af7b;
`

const IfNot = styled.div`
  font-family: 'Noto Sans Thai', 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  /* or 144% */

  text-align: center;

  /* Neutral / 600 */

  color: #4b5768;
`

const MessageBox = styled.div`
  font-family: 'Noto Sans Thai', 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  /* or 144% */

  text-align: center;

  /* Neutral / 600 */

  color: #4b5768;
  margin: 128px auto; 40px auto;
`
